import React, { useState, useRef, useEffect } from "react";

import { allowedImageExtensions } from "../../helpers";
import toastr from "toastr";
import ButtonFile from "../../components/form/ButtonFile";
import Input from "../../components/form/Input";
import Button from "../../components/form/Button";
import Image from "../../components/elements/Image";
import { postData } from "../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import slugify from "slugify";
import Textarea from "../../components/form/Textarea";

import { Editor } from "@tinymce/tinymce-react";
import { tinymceApiKey } from "../../helpers";
import { setTitle } from "../../helpers/MetaTag";

import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../helper/useWindowDimensions";

export default function Addblogs() {
  const { id } = useParams();
  if (id) {
    setTitle("Succession Planning Software for your Business with Succession Now | Edit Articles");
  } else {
    setTitle("Succession Planning Software for your Business with Succession Now | Add Articles");
  }
  const {  t } = useTranslation();
  const { width } = useWindowDimensions();
  const editorRef = useRef(null);
  const [details, setDetails] = useState({});
  const [title, setTitleMain] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [isManage, setIsManage] = useState(false);
  const [showLogo, setShowLogo] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [alias, setAlias] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Plan details
    const loadDetails = async () => {
      try {
        const result = await postData("blog/details", {
          id: id,
        });
        if (result.data) {
          setDetails(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadDetails();
  }, [id]);

  const onImgChange = (e) => {
    if (e.target.files[0]) {
      const ext = e.target.files[0].type.split("/")[1];
      if (![...allowedImageExtensions()].includes(ext)) {
        toastr.error("Please upload a valid logo");
      } else {
        var output = document.getElementById("image1");
        output.src = URL.createObjectURL(e.target.files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
        setImage(e.target.files[0]);
      }
    }
  };

  useEffect(() => {
    setTitleMain(details?.name);
    setDescription(details?.description);
    setShortDescription(details?.short_description);
    setAlias(details?.alias);
    setShowLogo(details?.image);
  }, [details]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", title);
    formData.append("description", description);
    formData.append("short_description", shortDescription);
    formData.append("alias", alias);
    formData.append("image", image);
    // console.log('formData',formData)
    setIsManage(true);
    try {
      let path = "";
      let payload = "";
      if (id) {
        path = "blog/update";
        formData.append("id", id);
        payload = formData;
        // {
        //   id: id,
        //   name: title,
        //   description: description,
        //   short_description: shortDescription,
        //   image: image,
        //   alias: alias
        // }
      } else {
        path = "blog/create";
        payload = formData;
      }
      const res = await postData(path, payload);
      if (res.status && res.status === 200) {
        toastr.success(res.message);
        navigate("/articles");
      } else {
        toastr.error(res.message);
      }
    } catch (err) {
      console.log(err.messege);
    }
    setIsManage(false);
  };

  return (
    <div className="border bg-white border-gray-200 p-4 shadow-md rounded-xl ">
        <div className="relative flex justify-between items-center mb-3 flex-wrap sm:flex-nowrap gap-y-4">
          <div className="text-2xl font-bold">{id ? t("edit_article") : t("add_article")}</div>
        </div>
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-3 border-r border-slate-200">
              <div className="p-2 2xl:p-4">
              <div className="py-6 px-6 flex flex-col space-y-2 relative">
                <div className="relative group w-full aspect-1 border-2  mx-auto overflow-hidden rounded-full border-dark-teal-500">
                  <Image src={showLogo} alt={"Admin"} width={"100%"} height={"100%"} effect={"blur"} classes={"object-contain"} id={"image1"} />
                </div>
              </div>
              <div className="divide-x divide-slate-200 flex items-center justify-center rounded-b border-t border-slate-200 pt-5">
                <ButtonFile buttonType={"button"} buttonIcon={"fa-light fa-image"} buttonIconPosition={"left"} buttonLabel={t("upload_image")} functions={onImgChange} accepts={"image/*"} />
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-9 flex flex-col">
                <div className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    <div className="relative col-span-12 sm:col-span-6">
                      <Input
                        label={t("title")}
                        labelClasses={"!text-xs"}
                        inputType={"text"}
                        inputName={"name"}
                        inputPlaceholder={t("give_title")}
                        inputValue={title}
                        setInput={(val) => {
                          setTitleMain(val);
                          //console.log(slugify(val, { remove: /[*+~.()'"!:@#]/g }))
                          setAlias(slugify(val, { remove: /[*+~.()'"!:@#]/g }).toLocaleLowerCase());
                          //this.setState({name: val,alias:slugify(val, { remove: /[*+~.()'"!:@#]/g }).toLocaleLowerCase()})
                        }}
                      />
                    </div>
                    <div className="relative col-span-12 sm:col-span-6">
                      <Input label={t("alias")} labelClasses={"!text-xs"} inputType={"text"} inputName={"alias"} inputPlaceholder={t("enter_alias")} inputValue={alias} setInput={setAlias} isDisabled={true} />
                    </div>
                  </div>
                  <div className="relative col-span-12 ">
                      <Textarea label={t("short_description")} labelClasses={"!text-xs"} inputValue={shortDescription} inputName={"short_description"} inputPlaceholder={t("short_description")} setTextarea={setShortDescription} />
                    </div>
                    <div className="relative col-span-12 ">
                      <Editor
                        apiKey={tinymceApiKey()}
                        onInit={(evt, editor) => (editorRef.current = editor)}
                        value={description}
                        name={"description"}
                        wrapperClassName="wrapperClassName"
                        init={{
                          height: width > 480 ? 500:240,
                          menubar: false,
                          plugins: ["code", "advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks code fullscreen", "insertdatetime media table paste code help wordcount"],
                          toolbar: "code | undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
                          //toolbar: "code | undo redo | formatselect | " + "bold italic backcolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help ",
                          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        }}
                        onEditorChange={(newText) => setDescription(newText)}
                      />
                    </div>
                </div>

                <div className="flex justify-end gap-4 mt-5">
                  <Button buttonClasses="" buttonLabelClasses="" buttonType={"button"} buttonIcon={isManage ? "fa-light fa-spinner fa-spin" : "fa-light fa-floppy-disk"} buttonIconPosition={"left"} buttonLabel={t("save")} functions={onSubmit} buttonHasLink={false} buttonDisabled={isManage} />
                </div>
          </div>
        </div>
    </div>
  );
}
